import { XStack } from "tamagui";
import { Spinner } from "./Spinner";
import { Paragraph } from "./Typography";
export const LoadMoreIndicator = ({
  fetchingMore,
  endReached,
  noMoreMessage
}: {
  fetchingMore: boolean;
  endReached: boolean;
  noMoreMessage: string;
}) => {
  return <XStack justifyContent="center" alignItems="center" py="$2" height="$4" data-sentry-element="XStack" data-sentry-component="LoadMoreIndicator" data-sentry-source-file="LoadMoreIndicator.tsx">
      <Spinner position="absolute" transition={{
      default: fetchingMore ? "enter" : "exit",
      opacity: "fade"
    }} opacity={fetchingMore ? 1 : 0} scale={fetchingMore ? 1 : 0.96} data-sentry-element="Spinner" data-sentry-source-file="LoadMoreIndicator.tsx" />
      <Paragraph position="absolute" transition={{
      default: endReached && !fetchingMore ? "enter" : "exit",
      opacity: "fade"
    }} opacity={endReached && !fetchingMore ? 1 : 0} scale={endReached && !fetchingMore ? 1 : 0.96} data-sentry-element="Paragraph" data-sentry-source-file="LoadMoreIndicator.tsx">
        {noMoreMessage}
      </Paragraph>
    </XStack>;
};